// noinspection ES6UnusedImports
import * as React from 'preact/compat'
import { nanoid } from 'nanoid'
import { useSignal } from '@preact/signals'
import { useCallback, useEffect } from 'preact/compat'
import Toast from './Toast'
import commonCss from '../../../css/common.pcss.json'
import StalcraftToast from "../Stalcraft/StalcraftToast";

declare global {
  interface Window {
    showToast: typeof showToast,
    hideToast: typeof hideToast,
    updateToast: typeof updateToast
  }
}

export interface ToastConfig {
  uuid?: string,
  type: 'success' | 'error' | 'info' | 'warning' | 'stalcraft-stalker' | 'stalcraft-bandit',
  text: string,
  timeout?: number,

  [key: string]: string | number
}

export let showToast: (config: ToastConfig) => string = () => ''
export let hideToast: (uuid: string) => void = () => {}
export let updateToast: (uuid: string, config: Partial<ToastConfig>) => void = () => {}

export default () => {
  const maxToasts = window.matchMedia('(min-width: 600px)').matches ? 4 : 1
  const toasts = useSignal<ToastConfig[]>([])
  const container = useSignal<HTMLDivElement>(null)
  const setContainer = useCallback((el: HTMLDivElement) => {
    container.value = el
  }, [container.value])
  useEffect(() => {
    showToast = (config) => {
      config.uuid = nanoid()
      toasts.value = [...toasts.value, config]
      return config.uuid
    }
    window.showToast = showToast
    hideToast = (uuid) => {
      toasts.value = toasts.value.filter(config => config.uuid !== uuid)
    }
    window.hideToast = hideToast
    updateToast = (uuid, config) => {
      const oldConfig = toasts.value.find(c => c.uuid === uuid)
      const newConfig = { ...oldConfig, ...config }
      toasts.value = toasts.value.map(c => c.uuid === uuid ? newConfig : c)
    }
    window.updateToast = updateToast
  }, [])

  useEffect(() => {
    if (!container.value || !HTMLElement.prototype.hasOwnProperty('popover')) {
      return
    }
    // @ts-ignore // TypeScript doesn't know about popover API
    container.value.showPopover()
  }, [container.value])

  if (toasts.value.length === 0) {
    return null
  }

  const Toasts = []
  for (let i = 0; i < Math.min(toasts.value.length, maxToasts); i++) {
    const config = toasts.value[i]
    if (config.type.startsWith('stalcraft-')) {
      Toasts.push(<StalcraftToast key={config.uuid} config={config}/>)
    } else {
      Toasts.push(<Toast key={config.uuid} config={config}/>)
    }
  }

  // @ts-ignore // TypeScript doesn't know about popover API
  return <div ref={setContainer} popover='manual' className={commonCss['toasts']}>
    {Toasts}
  </div>
}
